





















import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class MNoContent extends Vue {
  @Prop({ default: "mdi-magnify" }) icon!: string;
  @Prop({ default: "Noch keine Daten vorhanden." }) text!: string;
  @Prop({ default: "grey lighten-3" }) avatarColor!: string;
  @Prop({ default: "" }) cardClass!: string;
  @Prop() color?: string;
  @Prop({ type: Boolean, default: false }) dense?: boolean;
  @Prop() minHeight?: string;
}
